module.exports = __webpack_public_path__ + "static/media/logo-네이앤컴퍼니@2x.0f7f6ebb.png";